import { render, staticRenderFns } from "./取込.vue?vue&type=template&id=88b67eec&scoped=true&"
import script from "./取込.ts?vue&type=script&lang=ts&"
export * from "./取込.ts?vue&type=script&lang=ts&"
import style0 from "./取込.css?vue&type=style&index=0&id=88b67eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b67eec",
  null
  
)

export default component.exports